import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '@modules/components/snack-bar/snack-bar.component';
import { Observable, catchError, filter, throwError } from 'rxjs';

function filterHTTPResponse(event: HttpEvent<any>): event is HttpResponse<unknown> {
  return event instanceof HttpResponse;
}

@Injectable()
export class ErrorResponceInterceptor implements HttpInterceptor {
  private snack = inject(MatSnackBar);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      filter(filterHTTPResponse),
      catchError((err: HttpErrorResponse) => {
        if (
          err.status === HttpStatusCode.UnprocessableEntity ||
          err.status === HttpStatusCode.NotFound ||
          err.status === HttpStatusCode.InternalServerError ||
          err.status === HttpStatusCode.Forbidden ||
          err.status === HttpStatusCode.Conflict
        ) {
          const message = this.prepareErrorText(err);
          if (message) {
            this.snack.openFromComponent(SnackBarComponent, {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              data: { message },
              duration: 5000,
            });
          }
        }

        return throwError(() => err);
      }),
    );
  }

  prepareErrorText({ error }: HttpErrorResponse): string {
    const errors = error.error;

    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors) && errors.every((e) => typeof e === 'string')) return errors.join(', ');

    return '';
  }
}
